module.exports = __webpack_public_path__ + "static/media/rumput-kiri.283b7c31.svg";